(function () {
  var ZOOM_FACTOR = 2.5;

  function initHoverZoom() {
    document.querySelectorAll('.product__media-container.hover-zoom-active').forEach(setup);
  }

  function setup(container) {
    if (container._hoverZoom) return;
    container._hoverZoom = true;

    var lens = container.querySelector('.hover-zoom-lens');
    if (!lens) return;

    var img = container.querySelector('img');
    if (!img) return;

    // The .product__media-zoom::after pseudo-element covers the container at z-index:2
    // and intercepts all mouse events. Listen on that button instead.
    var zoomBtn = container.querySelector('.product__media-zoom');
    var eventTarget = zoomBtn || container;

    var bgLoaded = false;
    var sizeSet = false;

    function loadBg() {
      if (bgLoaded) return;
      var item = container.closest('.product__media-item');
      var url = (item && item.dataset.src) || img.currentSrc || img.src;
      lens.style.backgroundImage = 'url(' + url + ')';
      bgLoaded = true;
    }

    // The displayed img uses object-fit: contain, so it keeps its own aspect
    // ratio inside the (differently-shaped) media box. Mirror that for the zoom
    // lens: scale the background to the contain-fit of the image, then multiply
    // by ZOOM_FACTOR. Using two independent percentages ('250% 250%') stretched
    // the image to the box ratio and flattened it.
    function updateSize(rect) {
      var natW = img.naturalWidth;
      var natH = img.naturalHeight;
      if (!natW || !natH) return; // image not decoded yet — retry next move
      var fit = Math.min(rect.width / natW, rect.height / natH) * ZOOM_FACTOR;
      lens.style.backgroundSize = (natW * fit) + 'px ' + (natH * fit) + 'px';
      sizeSet = true;
    }

    eventTarget.addEventListener('mousemove', function (e) {
      if (window.innerWidth <= 749) return;
      loadBg();
      var rect = container.getBoundingClientRect();
      if (!sizeSet) updateSize(rect);
      var x = (e.clientX - rect.left) / rect.width;
      var y = (e.clientY - rect.top) / rect.height;
      lens.style.backgroundPosition = (x * 100) + '% ' + (y * 100) + '%';
      lens.classList.add('is-zooming');
    });

    eventTarget.addEventListener('mouseleave', function () {
      lens.classList.remove('is-zooming');
    });
  }

  // Init on ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverZoom);
  } else {
    initHoverZoom();
  }

  // Re-init on variant/gallery changes
  document.addEventListener('variant:media-change', function () {
    document.querySelectorAll('.product__media-container.hover-zoom-active').forEach(function (c) {
      c._hoverZoom = false;
    });
    initHoverZoom();
  });

  // Handle deferred Shopify sections that load after DOMContentLoaded
  document.addEventListener('shopify:section:load', initHoverZoom);

  // Fallback: re-scan periodically for a few seconds to catch late-rendered sections
  var retries = 0;
  var retryInterval = setInterval(function () {
    initHoverZoom();
    retries++;
    if (retries >= 10) clearInterval(retryInterval);
  }, 500);
})();
